var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons / bx-plus-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5415 7.29169H11.4582V11.4584H7.2915V13.5417H11.4582V17.7084H13.5415V13.5417H17.7082V11.4584H13.5415V7.29169Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5002 2.08331C6.75641 2.08331 2.0835 6.75623 2.0835 12.5C2.0835 18.2437 6.75641 22.9166 12.5002 22.9166C18.2439 22.9166 22.9168 18.2437 22.9168 12.5C22.9168 6.75623 18.2439 2.08331 12.5002 2.08331ZM12.5002 20.8333C7.90537 20.8333 4.16683 17.0948 4.16683 12.5C4.16683 7.90519 7.90537 4.16665 12.5002 4.16665C17.095 4.16665 20.8335 7.90519 20.8335 12.5C20.8335 17.0948 17.095 20.8333 12.5002 20.8333Z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconW);
export default __webpack_public_path__ + "static/media/plus-icon-w.97aa87430dc6291ec400699dc1fa07af.svg";
export { ForwardRef as ReactComponent };